import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom"; // Import useNavigate
import { useAuth } from "../contexts/AuthContext";
import { useLoading } from "../contexts/LoadingContext";
import Swal from "sweetalert2"; // Import SweetAlert2

const PermissionProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, isLoading: authLoading, hasPermission } = useAuth();
  const [pageLoading, setPageLoading] = useState(true);
  const { setIsLoading } = useLoading();
  const navigate = useNavigate(); // Use the useNavigate hook

  useEffect(() => {
    // Simulate a loading delay for the page
    const timeout = setTimeout(() => {
      setPageLoading(false);
    }, 200); // Adjust duration as needed

    return () => clearTimeout(timeout); // Cleanup timeout on unmount
  }, []);

  useEffect(() => {
    // Show loading when the auth check is in progress
    setIsLoading(authLoading || pageLoading);
  }, [authLoading, pageLoading, setIsLoading]);

  if (authLoading || pageLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            width: "62px",
            height: "62px",
          }}
          className="spinner-border text-primary"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !hasPermission(requiredPermission)) {
    // Modernized alert using SweetAlert2
    Swal.fire({
      icon: "error",
      title: "Access Denied",
      text: "Sorry, you are not allowed to access this page. Please contact the system administrator.",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      // Redirect after the user clicks "OK"
      navigate("/login", { replace: true }); // Use navigate to redirect
    });

    // Return null while the alert is being shown
    return null;
  }

  return children;
};

export default PermissionProtectedRoute;
